
export enum IdentifierType {
  CNPJ = 'CNPJ',
  EMAIL = 'EMAIL',
  MEMBER = 'MEMBER',
  UNKNOWN = 'UNKNOWN',
}

export interface ValidIdentifier {
  isValid: boolean;
  type: IdentifierType;
  mask: string | undefined;
}
